import { forwardRef } from 'react'
import BaseSearch, {
  SearchProps as BaseSearchProps,
} from 'antd/lib/input/Search'
import type { InputRef } from 'antd/lib/input/Input'
import { Icon } from 'components/common'

export interface SearchProps extends Omit<BaseSearchProps, 'prefix'> {}

export const Search = forwardRef<InputRef, SearchProps>((props, ref) => {
  const { loading, onSearch: customOnSearch, ...rest } = props

  const iconProps = {
    style: { color: '#6B7280' },
  }

  const onSearch: SearchProps['onSearch'] = (value, e) => {
    customOnSearch?.(value, e)
  }

  return (
    <>
      <BaseSearch
        ref={ref}
        prefix={
          loading ? (
            <Icon.LoadingOutlined {...iconProps} />
          ) : (
            <Icon.SearchOutlined {...iconProps} />
          )
        }
        onSearch={onSearch}
        {...rest}
      />
    </>
  )
})
